import { useQuery } from '@tanstack/react-query';
import { boatApi } from '../services/boatApi';

export function useManufacturerOptions() {
  return useQuery({
    queryKey: ['inventory', 'manufacturer-options'],
    queryFn: () => boatApi.getFieldOptions('manufacturer'),
    staleTime: 5 * 60_000,
  });
}
